<div (click)="handleClick($event)">
  <div
    class="switch-container rounded-3 d-flex justify-content-center align-items-center"
    [ngClass]="{ disabled: isNullValue }"
  >
    <span *ngIf="placeholder" class="text-white" translate>{{ placeholder }}</span>
    <bSwitch
      class="m-0 me-2"
      [formControl]="formControl"
      [switch-off-text]="' '"
      [switch-on-text]="' '"
      [switch-disabled]="isNullValue"
    ></bSwitch>
    <div
      [@popInPopOut]
      class="button-clear z-index-4 box-shadow shadow d-flex rounded-circle justify-content-center align-items-center"
      (click)="clear($event)"
      *ngIf="!isNullValue"
    >
      <i class="icon icon-times"></i>
    </div>
  </div>
</div>
